// import cbxLogo from "../../images/product1.png";
import cbxLogo from "../../images/product1.png";
import { HiOutlineDocumentReport } from "react-icons/hi";
import {
  AiOutlineInteraction,
  AiOutlineHome,
  AiOutlineUser,
  AiOutlineMail,
  AiOutlineSetting,
  AiOutlineCheckCircle,
  AiOutlineTeam,
  AiOutlineProfile,
  AiOutlineStock,
} from "react-icons/ai";
import {
  MdOutlinePayment,
  MdSettings,
  MdHolidayVillage,
  MdAccessTime,
  MdCategory,
  MdPunchClock,
  MdPerson,
  MdPeople
} from "react-icons/md";
import {
  BsClipboardCheck,
  BsCalendarCheck,
  BsCalendarDay,
  BsCalendarX,
  BsClockHistory,
  BsClock,
  BsPerson,
} from "react-icons/bs";

import {
  BsJournalText,
  BsClipboardData,
  BsCashStack,
  BsListCheck,
} from "react-icons/bs";

import { FaNotesMedical } from "react-icons/fa";

import { BsPersonPlus, BsPersonDash, BsPersonCheck } from "react-icons/bs";
import { FaUserClock } from "react-icons/fa";
import { MdBadge } from "react-icons/md";

import { FaTruckMoving, FaCarSide } from "react-icons/fa";
import { MdAssignmentLate, MdHowToReg } from "react-icons/md";
import { AiOutlineFileExclamation } from "react-icons/ai";
import { RiUserUnfollowLine } from "react-icons/ri";
import { HiOutlineDocumentAdd } from "react-icons/hi";
import { BsGraphUpArrow } from "react-icons/bs";
import { BiFolderOpen } from "react-icons/bi";

import Accordion from "@mui/material/Accordion";
import AccordionActions from "@mui/material/AccordionActions";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

import { FaMoneyCheckAlt } from "react-icons/fa";
import { AiOutlineCalendar } from "react-icons/ai";
import { BiCheckCircle } from "react-icons/bi";

import { MdPeopleOutline } from "react-icons/md";
import { MdPersonAddAlt } from "react-icons/md";
import { MdAutorenew } from "react-icons/md";
import { MdNoteAdd } from "react-icons/md";
import { MdEventBusy } from "react-icons/md";
import { MdCheckCircleOutline } from "react-icons/md";
import { HiUsers } from "react-icons/hi";

import { Link } from "react-router-dom";

import React, { useEffect, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";

// ─── Reusable nav‑link tile ──────────────────────────────────────────────────
const NavTile = ({ to, icon: Icon, label }) => (
  <div className="w-[80px] relative my-2">
    <NavLink
      to={to}
      className={({ isActive }) =>
        `relative flex flex-col justify-center items-center rounded-2xl text-center p-2 shadow-md
         transition-all duration-200 ease-in-out group
         ${isActive ? "bg-[#2663EB] text-white" : "bg-white hover:bg-blue-200 hover:text-[#2663EB]"}`
      }
    >
      {({ isActive }) => (
        <>
          {isActive && (
            <span className="absolute left-0 right-2 top-2 bottom-2 w-1 bg-blue-200 rounded-r mr-4" />
          )}
          <Icon
            className={`w-6 h-6 mb-1 transition-all duration-200 group-hover:scale-110 ${
              isActive ? "text-white" : "text-[#787878]"
            }`}
          />
          <span
            className={`text-[0.6rem] font-semibold leading-tight transition-colors duration-200 ${
              isActive ? "text-white" : "text-[#787878]"
            }`}
          >
            {label}
          </span>
        </>
      )}
    </NavLink>
  </div>
);

// ─── Accordion‑group header tile ─────────────────────────────────────────────
// Shows a blue‑tinted bg + left border when the group is expanded.
const AccordionHeader = ({ icon: Icon, label, expanded }) => (
  <div className="w-[80px] relative">
    <div
      className={`relative flex flex-col justify-center items-center rounded-2xl text-center p-2 shadow-md transition-all duration-200 group
        ${expanded ? "bg-blue-100 border-l-4 border-[#2663EB]" : "bg-white hover:bg-blue-200"}`}
    >
      {/* small "open" pip in top‑right corner */}
      {expanded && (
        <span className="absolute top-1 right-1 w-1.5 h-1.5 rounded-full bg-[#2663EB]" />
      )}
      <Icon
        className={`w-6 h-6 mb-1 group-hover:scale-110 transition-all duration-200 ${
          expanded ? "text-[#2663EB]" : "text-[#787878]"
        }`}
      />
      <span
        className={`text-[0.55rem] font-semibold text-center leading-tight ${
          expanded ? "text-[#2663EB]" : "text-[#787878]"
        }`}
      >
        {label}
      </span>
    </div>
  </div>
);

// ─── Shared MUI Accordion sx ─────────────────────────────────────────────────
const accordionSx = {
  boxShadow: "none",
  padding: "0",
  borderRadius: "18px !important",
  minHeight: "44px !important",
  "&.Mui-expanded": {
    background: "#EFF6FF",
    borderRadius: "12px",
    minHeight: "44px !important",
  },
};

const accordionSummarySx = {
  padding: 0,
  margin: 0,
  "& .MuiAccordionSummary-content": { margin: 0 },
};

const accordionDetailsSx = { padding: 0, marginTop: "8px" };

// ─── Main component ───────────────────────────────────────────────────────────
const NewSidebarOld = () => {
  const navigate = useNavigate();

  const onSignOut = () => {
    localStorage.clear();
    navigate("/");
  };

  // Only one accordion open at a time
  const [expandedPanel, setExpandedPanel] = useState(false);

  const handleChange = (panel) => (_event, isExpanded) => {
    setExpandedPanel(isExpanded ? panel : false);
  };

  return (
    <aside
      className="fixed top-0 left-0 h-screen w-24 bg-[#F9FAFA] overflow-y-auto scrollbar-none px-2 py-4"
      style={{ zIndex: 10 }}
    >
      <ul className="flex flex-col items-center gap-3 mt-20">

        {/* ── Home ── */}
        <NavTile to="home" icon={AiOutlineHome} label="Home" />

        {/* ── Employee ── */}
        <div className="w-[80px]">
          <Accordion
            expanded={expandedPanel === "employee"}
            onChange={handleChange("employee")}
            sx={accordionSx}
          >
            <AccordionSummary sx={accordionSummarySx}>
              <AccordionHeader
                icon={BsPerson}
                label="Employee"
                expanded={expandedPanel === "employee"}
              />
            </AccordionSummary>
            <AccordionDetails sx={accordionDetailsSx}>
              <NavTile to="emp_reg"              icon={MdPersonAddAlt}          label="Employee Registration" />
              <NavTile to="emp_list"             icon={MdPeopleOutline}         label="Employee List" />
              <NavTile to="empJoinExitReport"    icon={BsPersonDash}            label="Joining & Exit Report" />
              <NavTile to="empStatusReport"      icon={FaUserClock}             label="Employee Status Report" />
              <NavTile to="empVisaIDExpiryReport" icon={MdBadge}               label="Visa / Emirates ID Expiry" />
            </AccordionDetails>
          </Accordion>
        </div>

        {/* ── Team Management ── */}
        <NavTile to="teamManagementDashboard" icon={AiOutlineTeam} label="Team Management" />

        {/* ── Leave ── */}
        <div className="w-[80px]">
          <Accordion
            expanded={expandedPanel === "leave"}
            onChange={handleChange("leave")}
            sx={accordionSx}
          >
            <AccordionSummary sx={accordionSummarySx}>
              <AccordionHeader
                icon={MdEventBusy}
                label="Leave"
                expanded={expandedPanel === "leave"}
              />
            </AccordionSummary>
            <AccordionDetails sx={accordionDetailsSx}>
              <NavTile to="leaveallotment"              icon={AiOutlineProfile}    label="Allotment" />
              <NavTile to="leaveapplication"            icon={MdNoteAdd}           label="Application" />
              <NavTile to="leaveapproval"               icon={MdCheckCircleOutline} label="Approval" />
              <NavTile to="leaverejoin"                 icon={MdAutorenew}         label="Rejoin" />
              <NavTile to="leavecat"                    icon={MdCategory}          label="Category" />
              <NavTile to="leaveBalanceReport"          icon={BsClipboardData}     label="Balance Report" />
              <NavTile to="leaveLedger"                 icon={BsJournalText}       label="Leave Ledger" />
              <NavTile to="leaveRequestApprovalStatus"  icon={BsListCheck}         label="Requests & Approval Status" />
              <NavTile to="medicalLeaveTracking"        icon={FaNotesMedical}      label="Medical Leave Tracking" />
            </AccordionDetails>
          </Accordion>
        </div>

        {/* ── Payroll ── */}
        <div className="w-[80px]">
          <Accordion
            expanded={expandedPanel === "payroll"}
            onChange={handleChange("payroll")}
            sx={accordionSx}
          >
            <AccordionSummary sx={accordionSummarySx}>
              <AccordionHeader
                icon={MdOutlinePayment}
                label="Payroll Menu"
                expanded={expandedPanel === "payroll"}
              />
            </AccordionSummary>
            <AccordionDetails sx={accordionDetailsSx}>
              <NavTile to="payrollMain" icon={MdOutlinePayment} label="Payroll" />
              <NavTile to="payroll"     icon={MdOutlinePayment} label="Add / Deduct" />
              <NavTile to="wps"         icon={FaMoneyCheckAlt}  label="WPS" />
            </AccordionDetails>
          </Accordion>
        </div>

        {/* ── Attendance ── */}
        <div className="w-[80px]">
          <Accordion
            expanded={expandedPanel === "attendance"}
            onChange={handleChange("attendance")}
            sx={accordionSx}
          >
            <AccordionSummary sx={accordionSummarySx}>
              <AccordionHeader
                icon={MdAccessTime}
                label="Attendance"
                expanded={expandedPanel === "attendance"}
              />
            </AccordionSummary>
            <AccordionDetails sx={accordionDetailsSx}>
              <NavTile to="atdcevaluation"              icon={BiCheckCircle}    label="Evaluation" />
              <NavTile to="timesheet"                   icon={BsClipboardCheck} label="Timesheet" />
              <NavTile to="timesheetSummaryReport"      icon={BsClockHistory}   label="Timesheet Summary Report" />
              <NavTile to="attendancePunchDetailsReport" icon={MdPunchClock}    label="Attendance Punch Details" />
              <NavTile to="absenceReport"               icon={BsCalendarX}      label="Absence Report" />
              <NavTile to="overtimeReport"              icon={BsClock}          label="Overtime Report" />
              <NavTile to="lateEarlyReport"             icon={MdAccessTime}     label="Late Coming / Early Leaving Report" />
            </AccordionDetails>
          </Accordion>
        </div>

        {/* ── Reports ── */}
        <NavTile to="reportsMenu" icon={HiOutlineDocumentReport} label="Reports" />

        {/* ── Events / Calendar ── */}
        <NavTile to="bigCalendar" icon={AiOutlineCalendar} label="Events" />

        {/* ── Settings ── */}
        <div className="w-[80px]">
          <Accordion
            expanded={expandedPanel === "settings"}
            onChange={handleChange("settings")}
            sx={accordionSx}
          >
            <AccordionSummary sx={accordionSummarySx}>
              <AccordionHeader
                icon={MdSettings}
                label="Settings"
                expanded={expandedPanel === "settings"}
              />
            </AccordionSummary>
            <AccordionDetails sx={accordionDetailsSx}>
              <NavTile to="users" icon={MdPeople} label="Users" />
            </AccordionDetails>
            <AccordionDetails sx={accordionDetailsSx}>
              <NavTile to="holiday" icon={MdHolidayVillage} label="Holiday" />
            </AccordionDetails>
          </Accordion>
        </div>

        {/* ── End of Service ── */}
        <div className="w-[80px]">
          <Accordion
            expanded={expandedPanel === "eos"}
            onChange={handleChange("eos")}
            sx={accordionSx}
          >
            <AccordionSummary sx={accordionSummarySx}>
              <AccordionHeader
                icon={RiUserUnfollowLine}
                label="End of Service"
                expanded={expandedPanel === "eos"}
              />
            </AccordionSummary>
            <AccordionDetails sx={accordionDetailsSx}>
              <NavTile to="endOfServiceApplication" icon={HiOutlineDocumentAdd} label="Application" />
              <NavTile to="endOfServiceApproval"    icon={MdHowToReg}           label="Approval" />
            </AccordionDetails>
          </Accordion>
        </div>

        {/* ── Fleet Management ── */}
        <div className="w-[80px]">
          <Accordion
            expanded={expandedPanel === "fleet"}
            onChange={handleChange("fleet")}
            sx={accordionSx}
          >
            <AccordionSummary sx={accordionSummarySx}>
              <AccordionHeader
                icon={FaTruckMoving}
                label="Fleet Management"
                expanded={expandedPanel === "fleet"}
              />
            </AccordionSummary>
            <AccordionDetails sx={accordionDetailsSx}>
              <NavTile to="fleetInformation"       icon={FaCarSide}                label="Fleet Information" />
              <NavTile to="fleetList"              icon={MdAssignmentLate}          label="Fleet List" />
              <NavTile to="fleetInsuranceExpiry"   icon={AiOutlineFileExclamation}  label="Insurance Expiry" />
              <NavTile to="fleetRegistrationExpiry" icon={AiOutlineFileExclamation} label="Registration Expiry" />
            </AccordionDetails>
          </Accordion>
        </div>

        {/* ── Document Management ── */}
        <div className="w-[80px]">
          <Accordion
            expanded={expandedPanel === "docs"}
            onChange={handleChange("docs")}
            sx={accordionSx}
          >
            <AccordionSummary sx={accordionSummarySx}>
              <AccordionHeader
                icon={BiFolderOpen}
                label="Document Management"
                expanded={expandedPanel === "docs"}
              />
            </AccordionSummary>
            <AccordionDetails sx={accordionDetailsSx}>
              <NavTile to="documentManagement" icon={BiFolderOpen}  label="Document Management" />
              <NavTile to="documentExpiry"     icon={MdEventBusy}   label="Document Expiry" />
            </AccordionDetails>
          </Accordion>
        </div>

        <li className="w-full relative group my-4">
          <div className="flex">
            <img className="object-cover" src={cbxLogo} alt="" />
          </div>
        </li>
      </ul>
    </aside>
  );
};

export default NewSidebarOld;